// Display count of accepted and total job operators
import clsx from 'clsx';

import { useAuthContext } from '@/context/AuthContext';

import { getCompanyTrucksInfo } from '@isd/lib/firebase/db/helpers';
import { JobDoc } from '@isd/lib/firebase/db/metaTypes';

export default function JobOperatorsCount({
  jobDoc,
  classNames,
}: {
  jobDoc: JobDoc;
  classNames: string;
}) {
  const { userCompanyId } = useAuthContext();
  const companyTruckForUserCompany = getCompanyTrucksInfo(
    jobDoc,
    userCompanyId
  );
  const requestedTrucks = companyTruckForUserCompany.trucksRequestedCount;
  const assignedTrucks = companyTruckForUserCompany.trucksAssignedCount;
  const acceptedTrucks = companyTruckForUserCompany.trucksAcceptedCount;
  const countStr = `${acceptedTrucks}/${assignedTrucks}/${requestedTrucks} Trucks`;
  return (
    <div
      className={clsx(
        'job-operators-count flex items-end justify-end text-xs font-light',
        classNames
      )}
    >
      <div
        className="tooltip tooltip-left before:max-w-44 before:text-left"
        data-tip={`
          Trucks Accepted:  ${acceptedTrucks}.
          Trucks Assigned:  ${assignedTrucks}.
          Trucks Requested: ${requestedTrucks}.
        `}
      >
        {countStr}
      </div>
    </div>
  );
}
